define([
    "angular",
    "../../../../arrays/arrays",
    "lodash",
    "../../../hereMapsModule"
], function (angular, arrays, _, mapsModule) {
    "use strict";

    return mapsModule.service("nlgRouteMarkerHereService", [
        "$rootScope",
        "hereMapsMarkersFactory",
        function ($rootScope,
                  hereMapsMarkersFactory) {
            var stopMarkerById = {};


            return {
                setStopMarkerById: setStopMarkerById,
                toggleMarkers: toggleMarkers,
                toggleMarkersByModel: toggleMarkersByModel,
                cleanSelection: cleanSelection
            };

            function setStopMarkerById(stopMarkers) {
                if (!stopMarkerById) {
                    return;
                }
                stopMarkerById = stopMarkers;
            }

            function toggleMarkersByModel(routeMarkersModel) {
                var routeMarkers = [];
                _.forEach(routeMarkersModel, function (markerModel) {
                    var id = markerModel.stopId;
                    var markerHere = stopMarkerById[id];
                    if (markerHere) {
                        routeMarkers.push(markerHere);
                    }
                });
                toggleMarkers(routeMarkers);
            }

            function toggleMarkers(markers) {
                _.forEach(markers, function (markerHere) {
                    var markerModel = markerHere.getData();
                    var routeMarkerSelectionIdentity = getRouteMarkerSelectionIdentity(markerModel);
                    if (isSelected(routeMarkerSelectionIdentity)) {
                        setDefaultIcon(markerHere, markerModel);
                        arrays.remove($rootScope.selectedHereMapsRouteMarkersModel, routeMarkerSelectionIdentity);
                        return;
                    }
                    setSelectedIcon(markerHere, markerModel);
                    $rootScope.selectedHereMapsRouteMarkersModel.push(routeMarkerSelectionIdentity);
                });
            }

            function cleanSelection() {
                var copy = arrays.copy($rootScope.selectedHereMapsRouteMarkersModel);
                _.forEach(copy, function (routeMarkersModel) {
                    var markerHere = stopMarkerById[routeMarkersModel.stop.id];
                    var markerModel = markerHere.getData();
                    setDefaultIcon(markerHere, markerModel);
                    var routeMarkerSelectionIdentity = getRouteMarkerSelectionIdentity(markerModel);
                    arrays.remove($rootScope.selectedHereMapsRouteMarkersModel, routeMarkerSelectionIdentity);
                });
            }

            function getRouteMarkerSelectionIdentity(markerModel) {
                return {
                    tripId: markerModel.routePresentationNode.id,
                    stop: markerModel.stop,
                };
            }

            function isSelected(marker) {
                return arrays.contains($rootScope.selectedHereMapsRouteMarkersModel, marker);
            }

            function setSelectedIcon(markerHere, markerModel) {
                var selectedIcon =
                    hereMapsMarkersFactory.createSelectedIcon({data: markerModel});
                markerHere.setIcon(selectedIcon.hereIcon);
                markerModel.icon = selectedIcon.icon;
            }

            function setDefaultIcon(markerHere, markerModel) {
                var selectedIcon =
                    hereMapsMarkersFactory.createDefaultIcon({data: markerModel});
                markerHere.setIcon(selectedIcon.hereIcon);
                markerModel.icon = selectedIcon.icon;
            }
        }
    ]);
});